<template>
  <div>
    <el-table :data="projects">
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="amount" label="数量"></el-table-column>
      <el-table-column prop="executeTime" label="执行时间">
        <template slot-scope="scope">
          <span>{{ scope.row.executeTime | moment }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="status  " label="状态">
        <template slot-scope="scope">{{ statusTypes[scope.row.status] }}</template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-view"
              @click="viewDetail(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Pagination from "components/pagination";
import { STATUS_TYPES } from "../../constants";

export default {
  name: "orderTaskProjectList",
  data() {
    return {
      statusTypes: STATUS_TYPES
    };
  },
  computed: {
    ...mapState("orderTaskProject", ["totalCount", "projects", "pagination"])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapMutations("orderTaskProject", ["setEditingProject", "delete"]),
    ...mapActions("orderTaskProject", ["delete"]),
    viewDetail(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
    handleRemove(id) {
      this.$confirm("确定删除吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.delete({ id }).then(() => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.$emit("refresh", {
            page: 1
          });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
